import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse10 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHouse10.js.map